import React from 'react'
import { QrReader } from 'react-qr-reader'
import ScanOverlay from './ScanOverlay'
import { debounce } from '../../../helpers/debounce'

export default function ScannerQR ({ handleSubmit }) {
  // const [scanResult, setScanResult] = useState('')

  if (navigator.mediaDevices === undefined) {
    navigator.mediaDevices = {}
  }

  if (navigator.mediaDevices.getUserMedia === undefined) {
    navigator.mediaDevices.getUserMedia = function (constraints) {
      // Primero consiga el getUserMedia heredado, si está presente
      var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia

      // Algunos navegadores simplemente no lo implementan: devuelven una promesa rechazada con un error
      // para mantener una interfaz consistente
      if (!getUserMedia) {
        return Promise.reject(new Error('Navegador no compatible'))
      }

      // De lo contrario, envuelve la llamada al antiguo navigator.getUserMedia con una Promise
      return new Promise(function (resolve, reject) {
        getUserMedia.call(navigator, constraints, resolve, reject)
      })
    }
  }

  navigator.mediaDevices.getUserMedia({ video: { facingMode: { ideal: 'environment' } } })
    .then(function (stream) {
      var video = document.querySelector('video')
      // Los navegadores más antiguos pueden no tener srcObject
      if ('srcObject' in video) {
        video.srcObject = stream
      } else {
        video.src = window.URL.createObjectURL(stream)
      }

      video.onloadedmetadata = function (e) {
        video.play()
      }
    })
    .catch(function (err) {
      console.log(err.name + ': ' + err.message)
      // setScanResult(err.message)
    })

  const handleResult = (result) => {
    if (result) {
      debounce(handleSubmit(result.text), 500)
    }
  }

  return (
    <div>
      <h4 className='titulo-scanner-qr-calado'>Escanee el código QR</h4>
      <QrReader
        className='qr-reader'
        delay={10000}
        key='environmentQR'
        autoFocus
        onResult={handleResult}
        legacyMode
        constraints={{ facingMode: 'environment' }}
        ViewFinder={ScanOverlay}
        videoContainerStyle={{ width: '98%', margin: 'auto' }}
      />
    </div>
  )
}
